import { isUtcIsoString } from '../is-utc-iso-string'

export function jsonTryParse(input: any) {
  if (typeof input === 'string') {
    try {
      const reviver = (_key: string, value: any) => {
        if (isUtcIsoString(value)) {
          return new Date(value)
        }
        return value
      }

      return JSON.parse(input, reviver)
    } catch {
      return false
    }
  } else {
    return input
  }
}
